var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 10.0026H8.66659V11.3359H7.33325V10.0026ZM7.33325 4.66927H8.66659V8.66927H7.33325V4.66927ZM7.99325 1.33594C4.31325 1.33594 1.33325 4.3226 1.33325 8.0026C1.33325 11.6826 4.31325 14.6693 7.99325 14.6693C11.6799 14.6693 14.6666 11.6826 14.6666 8.0026C14.6666 4.3226 11.6799 1.33594 7.99325 1.33594ZM7.99992 13.3359C5.05325 13.3359 2.66659 10.9493 2.66659 8.0026C2.66659 5.05594 5.05325 2.66927 7.99992 2.66927C10.9466 2.66927 13.3333 5.05594 13.3333 8.0026C13.3333 10.9493 10.9466 13.3359 7.99992 13.3359Z",
    fill: "#F19E41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutline);
export default __webpack_public_path__ + "static/media/error_outline.48beb4df4ff1b6dadaf263ecd9688cb4.svg";
export { ForwardRef as ReactComponent };